
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'email-input',

	props: {
		autofocus: {
			type: Boolean,
			default: false
		}
	},

	emits: ['input-value'],

	data() {
		return {
			email: ''
		};
	},

	methods: {
		inputValue() {
			if (!this.email) return;
			this.$emit('input-value', this.email);
			this.email = '';
		}
	}
});
